import { render } from "./coupon-details-page.vue?vue&type=template&id=b2380e80&scoped=true&ts=true"
import script from "./coupon-details-page.vue?vue&type=script&lang=ts"
export * from "./coupon-details-page.vue?vue&type=script&lang=ts"

import "./coupon-details-page.vue?vue&type=style&index=0&id=b2380e80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2380e80"]])

export default __exports__